module.exports = __webpack_public_path__ + "images/475170271b845e874fa0cbd4a72fc4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/travel-plus-logo.png
// module id = 1307
// module chunks = 0